import AllCity from './AllCity'

export default AllCity
